import React from 'react'
import ChartBar from './ChartBar'

export * from './ChartBar'

export default React.memo(ChartBar)
